import { FeatureFlagName, ModuleName } from 'shared/clients/client-spa-ConfigurationGroup';

interface FeatureFlag {
  flagName: number;
  value: boolean;
}

class FeatureFlagsService {
  featureFlags: FeatureFlag[] = [];
  domain = `${window.location.protocol}//${window.location.host}`;

  public async fetchFeatureFlags(): Promise<void> {
    const featureFlagsResponse = await fetch(`${this.domain}/configuration/feature-flags?module=${ModuleName.Host}`);
    const featureFlagsArray = await featureFlagsResponse?.json().catch(() => []);

    if(Symbol.iterator in Object(featureFlagsArray)) {
      this.featureFlags.push(...featureFlagsArray);
    }
  }

  public getFeatureFlagValue(flagName: FeatureFlagName): boolean {
    const flag = this.featureFlags.find(f => f.flagName === flagName);

    return !!flag && flag.value;
    }
}

export default new FeatureFlagsService();
